import { memo } from 'react';

import ZapierIcon from '@/assets/zapier-logo.svg?react';
import { Logo, LogoProps } from '@/components/core';

export type ZapierLogoProps = LogoProps;

const IZapierLogo = ({ className, ...rest }: ZapierLogoProps) => {
  return (
    <Logo className={className} {...rest}>
      <ZapierIcon />
    </Logo>
  );
};

export const ZapierLogo = memo(IZapierLogo) as typeof IZapierLogo;
